@if (!disabled && (maxFiles === 0 || files().length < maxFiles)) {
  <div
    class="group flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-gray-300 px-6 py-10 text-center transition-colors duration-200 cursor-pointer hover:border-blue-400 hover:bg-blue-50"
    [class.border-blue-500]="isDragOver()"
    [class.bg-blue-50]="isDragOver()"
    (click)="fileInput.click()"
  >
    <input
      #fileInput
      type="file"
      [accept]="accept"
      [multiple]="multiple"
      class="hidden"
      (change)="onFileSelect($event)"
    />

    <svg-icon
      src="assets/icons/icon-upload-small.svg"
      class="w-12 text-gray-400 transition-colors group-hover:text-blue-500"
      [class.!text-blue-500]="isDragOver()"
    ></svg-icon>
    <p class="text-base font-medium text-gray-800 transition-colors group-hover:text-blue-500">
      {{ 'eclass.dropzone.arraste-arquivos' | translate }}
    </p>
    <p class="text-sm text-gray-500 transition-colors group-hover:text-blue-500">
      {{ 'eclass.dropzone.clique-selecionar' | translate }}
    </p>
    <span class="text-xs text-gray-400 transition-colors group-hover:text-blue-400">{{
      'eclass.dropzone.max-por-arquivo' | translate: { size: maxSizeMB }
    }}</span>
    @if (maxFiles > 0) {
      <span class="text-xs font-semibold text-gray-400 transition-colors group-hover:text-blue-400 mt-1">
        {{
          maxFiles > 1
            ? ('eclass.dropzone.max-files.plural' | translate: { count: maxFiles })
            : ('eclass.dropzone.max-files.singular' | translate)
        }}
      </span>
    }
  </div>
}

@if (files().length > 0) {
  <ul class="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
    @for (f of files(); track f.id) {
      <li
        class="flex min-h-[4rem] w-full! items-center justify-between gap-3 col-span-1 rounded-lg border p-2 shadow-md transition-colors"
        [ngClass]="{
          'bg-blue-50/50 border-blue-200': f.isExisting,
          'bg-base-gray-50 border-transparent': !f.isExisting && f.status !== 'error',
          'border-base-status-danger': f.status === 'error',
        }"
      >
        <!-- Ícone do arquivo -->
        <svg-icon class="flex w-8 justify-center shrink-0" [src]="getFileIcon(f.name)"></svg-icon>

        <div class="flex-1 min-w-0">
          <p class="text-md font-semibold truncate">{{ f.name }}</p>
          <p class="text-base text-base-gray-400 mt-0.5 mb-1">{{ formatSize(f.size) }}</p>

          @if (!f.isExisting) {
            <div class="h-1 w-full rounded-full bg-base-gray-200 overflow-hidden">
              <div
                class="h-full rounded-full transition-all duration-300"
                [class.bg-modules-school-500]="f.status === 'uploading' || f.status === 'waiting'"
                [class.bg-base-status-success]="f.status === 'done'"
                [class.bg-base-status-danger]="f.status === 'error'"
                [style.width.%]="f.progress"
              ></div>
            </div>
          }

          @if (f.errorMessage) {
            <p class="text-[11px] text-base-status-danger mt-1">{{ f.errorMessage }}</p>
          }
        </div>

        <!-- Badge de status -->
        <span
          class="shrink-0 rounded-full px-2 py-0.5 text-[11px] font-bold whitespace-nowrap"
          [class.text-blue-600]="f.isExisting"
          [class.text-modules-school-500]="!f.isExisting && (f.status === 'waiting' || f.status === 'uploading')"
          [class.text-base-status-success]="!f.isExisting && f.status === 'done'"
          [class.text-base-status-danger]="!f.isExisting && f.status === 'error'"
        >
          @if (f.isExisting) {
            💾 {{ 'eclass.dropzone.salvo' | translate }}
          } @else if (f.status === 'waiting') {
            ⏳ {{ 'eclass.dropzone.aguardando' | translate }}
          } @else if (f.status === 'uploading') {
            {{ f.progress }}%
          } @else if (f.status === 'done') {
            ✓ {{ 'eclass.dropzone.enviado' | translate }}
          } @else if (f.status === 'error') {
            ✗ {{ 'eclass.dropzone.erro' | translate }}
          } @else {
            —
          }
        </span>

        <div class="flex items-center gap-2 shrink-0">
          @if (f.status === 'error' && f.canRetry !== false && !disabled) {
            <svg-icon
              [title]="'eclass.dropzone.tentar-novamente' | translate"
              class="w-6 cursor-pointer text-base-gray-400 hover:text-modules-school-500 transition-colors"
              (click)="onRetryFile(f.id, $event)"
              src="assets/icons/icon-refresh.svg"
            ></svg-icon>
          }
          @if ((f.isExisting || f.uploadedFile) && downloadable) {
            <svg-icon
              [title]="'eclass.dropzone.download' | translate"
              class="w-6 cursor-pointer text-base-gray-400 hover:text-modules-school-500 transition-colors"
              (click)="onDownloadFile(f, $event)"
              src="assets/icons/icon-download.svg"
            ></svg-icon>
          }
          @if ((f.isExisting || f.uploadedFile) && previewable) {
            <svg-icon
              [title]="'eclass.dropzone.preview' | translate"
              class="w-6 cursor-pointer text-base-gray-400 hover:text-modules-school-500 transition-colors"
              (click)="onPreviewFile(f, $event)"
              src="assets/icons/icon-eyes.svg"
            ></svg-icon>
          }
          @if (!disabled) {
            <svg-icon
              [title]="'eclass.dropzone.remover' | translate"
              class="w-8 cursor-pointer text-base-status-danger"
              (click)="onRemoveFile(f.id, $event)"
              src="assets/icons/icon-close.svg"
            ></svg-icon>
          }
        </div>
      </li>
    }
  </ul>

  <!-- Resumo + limpar -->
  <div class="mt-3 flex flex-wrap items-center gap-4 text-xs text-gray-500">
    <span
      >{{ 'eclass.dropzone.total' | translate }}: <strong class="text-gray-700">{{ totalFiles() }}</strong></span
    >
    <span class="text-emerald-700"
      >{{ 'eclass.dropzone.enviados' | translate }}: <strong>{{ doneFiles() }}</strong></span
    >

    @if (errorFiles() > 0) {
      <span class="text-red-700"
        >{{ 'eclass.dropzone.erros' | translate }}: <strong>{{ errorFiles() }}</strong></span
      >
    }
    @if (uploadingFiles() > 0) {
      <span class="text-blue-700"
        >{{ 'eclass.dropzone.enviando' | translate }}: <strong>{{ uploadingFiles() }}</strong></span
      >
    }
    @if (!disabled) {
      <button
        app-outline-button
        class="cursor-pointer ml-auto px-4 py-1 text-xs uppercase border border-red-500 rounded-lg text-red-500 hover:bg-red-500 hover:text-white transition-colors"
        (click)="clearAll()"
      >
        {{ 'eclass.dropzone.limpar-tudo' | translate }}
      </button>
    }
  </div>
}
